// 引入 React。
import React from 'react';
// 引入骨架屏组件。
import Skeleton from 'react-loading-skeleton';
// 引入骨架屏样式。
import 'react-loading-skeleton/dist/skeleton.css';
// 引入样式模块。
import styles from './index.module.scss';

// 单条帖子骨架项。
export const SkeletonPostItem: React.FC = () => {
  return (
    <div className={styles.item}>
      <div className={styles.upperBody}>
        <div className={styles.textContent}>
          <Skeleton width={400} height={22} className={styles.title} />
          <div className={styles.summary}>
            <Skeleton count={2} height={16} style={{ marginBottom: 4 }} />
          </div>
        </div>
        <div className={styles.cover}>
          <Skeleton height="100%" />
        </div>
      </div>
      <div className={styles.footer}>
        <Skeleton width={80} height={16} />
        <div className={styles.actions}>
          <Skeleton circle width={24} height={24} className={styles.actionIcon} />
          <Skeleton circle width={24} height={24} className={styles.actionIcon} />
          <Skeleton circle width={24} height={24} className={styles.actionIcon} />
        </div>
      </div>
    </div>
  );
};

// 单条评论骨架项。结构对齐 UserReplyList 实际 DOM：我的回复 + 引用块两行 + 原帖标题 + 时间。
export const SkeletonReplyItem: React.FC = () => {
  return (
    <div className={styles.replyItem}>
      {/* 我的回复内容（单行） */}
      <Skeleton width={420} height={22} className={styles.replyTitle} />
      {/* 引用块（两行摘要） */}
      <div className={styles.replyQuote}>
        <Skeleton count={2} height={16} style={{ marginBottom: 4 }} />
      </div>
      {/* 原帖标题 */}
      <Skeleton width={260} height={16} className={styles.replyThreadTitle} />
      {/* 时间 */}
      <Skeleton width={90} height={14} className={styles.replyTime} />
    </div>
  );
};

// 帖子列表骨架组件。
const SkeletonUserPostList: React.FC = () => {
  // Render a few skeleton items to simulate a list
  // 固定渲染 3 条骨架项。
  const items = Array.from({ length: 3 });

  return (
    <div className={styles.list}>
      {items.map((_, index) => (
        <SkeletonPostItem key={index} />
      ))}
    </div>
  );
};

// 导出组件。
export default SkeletonUserPostList;
